import { render, staticRenderFns } from "./meituan-auth.vue?vue&type=template&id=8e3dfdc0"
import script from "./meituan-auth.vue?vue&type=script&lang=js"
export * from "./meituan-auth.vue?vue&type=script&lang=js"
import style0 from "./meituan-auth.vue?vue&type=style&index=0&id=8e3dfdc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports